import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Content } from "../components/content/Content";
import { Footer } from "../components/footer/Footer";
import { Header } from "../components/header/Header";
import { StyledWrapper } from "./styled";
export var MainPage = function () {
    return _jsxs(StyledWrapper, { children: [_jsx(Header, {}), _jsx(Content, {}), _jsx(Footer, {})] });
};
